import React from "react";
import { Link } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const notifyTopRight = (notiText, options = {}) => {
  console.log(notiText);
  toast.success(`✅ ${notiText} !`, {
    position: "top-right",
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    ...options,
  });
};

const notifyInfo = (notiText) => {
  toast.info(`❓ ${notiText} !`, {
    position: "top-right",
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  });
};
const notifyWarning = (notiText, options = {}) => {
  toast.warn(`❗ ${notiText} !`, {
    position: "top-right",
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    ...options,
  });
};

// const notifyError = (notiText) => {
//   toast.error(`❌ ${notiText} !`, {
//     position: "top-right",
//     autoClose: 15000,
//     hideProgressBar: false,
//     closeOnClick: true,
//     pauseOnHover: true,
//     draggable: true,
//     progress: undefined,
//   });
// };
const notifyError = (notiText, options = {}) => {
  toast.error(<div style={{ whiteSpace: "pre-line" }}>{notiText}</div>, {
    position: "top-right",
    autoClose: 15000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    ...options,
  });
};

const Toast = () => {
  return (
    // <ToastContainer
    //   position="top-right"
    //   autoClose={3000}
    //   hideProgressBar={false}
    //   newestOnTop
    //   closeOnClick
    //   rtl={false}
    //   pauseOnFocusLoss
    //   draggable
    //   pauseOnHover
    // />
    <ToastContainer enableMultiContainer />
  );
};

export default Toast;
export { notifyTopRight, notifyInfo, notifyWarning, notifyError };
